module.exports = __webpack_public_path__ + "static/media/risqover-white.f63f6705.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/appshell/header/risqover-white.svg
// module id = 985
// module chunks = 0